
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notice/[[...pathParams]]",
      function () {
        return require("private-next-pages/notice/[[...pathParams]]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notice/[[...pathParams]]"])
      });
    }
  